import React, { useState } from "react";
import Pagination from "../Pagination/Pagination";
import { FiEdit, FiTrash2 } from "react-icons/fi";
import EditPopup from "../../Popup/EditPopup";

import SearchPopup from "../../Popup copy/SearchPopup";
import DeletePopups from "../../Popup copy/DeletePopups";

const tableData = [
  { hsn: "1002", related: "1002, 3245, 6483" },
  { hsn: "1235", related: "1002, 3245, 6483" },
  { hsn: "etc", related: "Etcetera" },
];

export default function Table() {
  const [showEdit, setShowEdit] = useState();
  const [showDelete, setShowDelete] = useState();
  return (
    <div >
    <table className="w-full text-left  border rounded-lg mt-2">
      <thead className="bg-gray-100 ">
        <tr>
        
          <th className="p-2 border text-center text-gray-500 font-normal">HSN ↓</th>
          <th className="p-2 border text-center text-gray-500 font-normal">Related HSN ↓</th>
          <th className="p-2 border text-center text-gray-500 font-normal">Action ↓</th>
         
        </tr>
       
        <tr>
          <th className="p-2 border">
            <input className="w-full border px-2 py-1 rounded-lg focus:outline-none font-normal" placeholder="Search" />
          </th>
          <th className="p-2 border">
            <input className="w-full border px-2 py-1 rounded-lg focus:outline-none font-normal" placeholder="Search" />
          </th>
          <th className="p-2 border">
            <input className="w-full border px-2 py-1 rounded-lg focus:outline-none font-normal" placeholder="Search" />
          </th>
        </tr>
      </thead>
      <tbody>
        {tableData.map((row, index) => (
          <tr key={index} >
            <td className="p-1 border text-center text-gray-700">{row.hsn}</td>
            <td className="p-1 border text-center text-gray-700">{row.related}</td>
         
<td className="p-2 border">
  <div className="flex justify-center items-center gap-4 text-xl">
    <FiEdit className="cursor-pointer text-gray-800 "  onClick={() => setShowEdit(true)}/>
    <FiTrash2 className="cursor-pointer text-red-600 "onClick={() => setShowDelete(true)} />
  </div>
</td>
          </tr>
        ))}
      </tbody>
    </table>
    <div className="mt-3">
        <Pagination />
    </div>
     <SearchPopup isOpen={showEdit} onClose={() => setShowEdit(false)} />
      <DeletePopups isOpen={showDelete} onClose={() => setShowDelete(false)} />
    </div>
  );
}


